import { ErrorMessage } from '@/shared/utils';
import { ProfileSkillLevelResponse, ProfileSkillLevelSchema } from '../types/profile-skill-levels';
import { profileSkillLevelValidator } from './profile-skill-level-response-validator';
import { profileSkillLevelsPayloadAdapter } from './profile-skill-level-response-adapter';
import {
  TaskEither,
  Either,
  isLeft,
  left,
  right,
  isRight,
  taskEither,
  fetchData,
} from '@shared-commons/utils';

export const createProfileSkillLevel = (
  email: string | undefined,
  accessToken: string | null,
  profileSkillLevel: ProfileSkillLevelSchema,
): TaskEither<Error, ProfileSkillLevelResponse> => {
  const validateProfileSkillLevel = (
    payload: ProfileSkillLevelResponse,
  ): Either<Error, ProfileSkillLevelResponse> => {
    const validatedInstrumentOptions = profileSkillLevelValidator(payload);
    if (isLeft(validatedInstrumentOptions)) {
      const errorMessage = new Error(validatedInstrumentOptions.value.message);
      return left(new Error(ErrorMessage('Validation error') + errorMessage));
    }
    return right(validatedInstrumentOptions.value);
  };

  const adapter = (
    input: ProfileSkillLevelResponse,
  ): TaskEither<Error, ProfileSkillLevelResponse> => {
    const adaptTask: TaskEither<Error, ProfileSkillLevelResponse> = async () => {
      //TODO @Leo To fix the type error, you need to cast the value of the adaptedInstrumentOptions to the expected type.

      try {
        const adaptedInstrumentOptions = (await profileSkillLevelsPayloadAdapter(
          input,
        )()) as Either<Error, { message: string }>;
        if (isRight(adaptedInstrumentOptions)) {
          return right(adaptedInstrumentOptions.value);
        } else {
          throw new Error(adaptedInstrumentOptions.value.message);
        }
      } catch (error) {
        return left(
          new Error(ErrorMessage('Failed to adapt users') + ': ' + (error as Error).message),
        );
      }
    };

    return taskEither(adaptTask);
  };

  return fetchData<ProfileSkillLevelResponse>(
    `${process.env.NEXT_PUBLIC_HOST}/api/profile/skill-levels/create`,
    (input) => adapter(input),
    validateProfileSkillLevel,
    'POST',
    {
      Authorization: `Bearer ${accessToken}`,
    },
    JSON.stringify({
      email,
      ...profileSkillLevel,
    }),
  );
};
